// bluaIQ — human messages for API error codes (PR3, C7).
//
// Bug: a STARTER account opening Proposals or Receipts saw the raw server
// code "plan_required" or a red "Could not load" box right next to the
// upgrade card. Map the known codes to plain bilingual sentences; anything
// unknown falls back to the caller's generic message (never a raw code).

const MESSAGES: Record<string, { es: string; en: string }> = {
  plan_required: {
    es: 'Esta función es parte del plan PRO. Puedes activarlo en Membresía.',
    en: 'This feature is part of the PRO plan. You can activate it in Membership.',
  },
  subscription_past_due: {
    es: 'Tu pago está pendiente. Actualiza tu método de pago en Membresía.',
    en: 'Your payment is past due. Update your payment method in Membership.',
  },
  read_only: {
    es: 'Tu cuenta está en modo solo lectura. Activa un plan en Membresía para editar.',
    en: 'Your account is read-only. Activate a plan in Membership to edit.',
  },
}

/** True when the value is a known API error code (not a human sentence). */
export function isKnownApiErrorCode(code: unknown): boolean {
  return typeof code === 'string' && Object.prototype.hasOwnProperty.call(MESSAGES, code)
}

/** Human message for a known code, else the fallback. Never returns a raw code. */
export function friendlyApiError(code: unknown, isEs: boolean, fallback: string): string {
  if (isKnownApiErrorCode(code)) {
    const m = MESSAGES[code as string]
    return isEs ? m.es : m.en
  }
  // snake_case strings are codes, not sentences → never show them raw
  if (typeof code !== 'string' || !code.trim() || /^[a-z0-9]+(_[a-z0-9]+)+$/.test(code.trim())) return fallback
  return code
}

/** 402 from a plan / billing gate: the page shows the upgrade card instead of an error. */
export function isPlanGateStatus(status: number): boolean {
  return status === 402
}
